import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type UiLanguage = 'pl' | 'en';

export interface SettingsStoreState {
  uiLanguage: UiLanguage;
  syncEnabled: boolean;
  setUiLanguage: (uiLanguage: UiLanguage) => void;
  setSyncEnabled: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsStoreState>()(
  persist(
    (set) => ({
      uiLanguage: 'pl',
      syncEnabled: false,
      setUiLanguage: (uiLanguage) => set({ uiLanguage }),
      setSyncEnabled: (syncEnabled) => set({ syncEnabled }),
    }),
    {
      name: 'cv-creator-settings',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        uiLanguage: state.uiLanguage,
        syncEnabled: state.syncEnabled,
      }),
    },
  ),
);
